import { ReactElement, ReactNode } from 'react';

import {
  SxProps,
  HexIcon,
  HexIconElementProps,
  Placeholder as StatusMessage,
} from '@cast/design-system';

type Props = {
  icon?: ReactElement<HexIconElementProps>;
  title?: ReactNode;
  body?: ReactNode;
  sx?: SxProps;
};

export const NoNotifications = ({
  icon = <HexIcon variant="notification" />,
  title = 'No new notifications',
  body = 'Check back later for any new notifications.',
  sx,
}: Props) => {
  return (
    <StatusMessage
      icon={icon}
      title={title}
      body={body}
      sx={sx}
      bodyProps={{ mt: 0 }}
    />
  );
};
